module.exports = __webpack_public_path__ + "img/metrics1.277301c1.svg";